import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	row-gap: 40px;
	height: 800px;

	transition: opacity 0.25s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

const StyledSectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledMoneyButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledMoneyButtonsFirstRow = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	column-gap: 20px;
`;

const StyledMoneyButtonsSecondRow = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	column-gap: 20px;
`;

const StyledSummaryContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	align-items: center;
	row-gap: 20px;
	column-gap: 10px;
	pointer-events: none;
	color: #ffffff;
	font-size: 18px;

	& ${Text}:nth-child(3n + 1) {
		opacity: 0.25;
		font-weight: 400;
	}

	& ${Text}:nth-child(3n + 2) {
		justify-self: end;
		font-weight: 500;
	}

	img {
		opacity: 0.5;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledCardNumberInputContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		img {
			opacity: 1;
			filter: invert(1);
		}
	}
`;

export {
	StyledButtonContent,
	StyledCardNumberInputContainer,
	StyledContainer,
	StyledMoneyButtonsContainer,
	StyledMoneyButtonsFirstRow,
	StyledMoneyButtonsSecondRow,
	StyledSectionContainer,
	StyledSummaryContainer,
};
